<template>
  <div class="container flex-row-wrap">
    <p>site internet réalisé par</p>
    <img src="../img/footer/logo_christopheds.svg" class="christopheds" alt="">
    <p>et</p>
    <img src="../img/footer/logo_alpitech_for_cyberdine.png" class="alpitech" alt="">
  </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
  .container {
    min-height: 50px;
    width: calc(100% - 20px);
    padding: 0 10px;

    background-color: #584d70;
  }

  p {
    margin: 15px 0;
    color: white;
  }
  img {
    margin: 0 15px;
  }
  .christopheds {
    height: 30px;
    margin: 10px 15px;
  }
  .alpitech {
    height: 40px;
    margin: 5px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue